import { OnBoardingCard } from 'components/OnBoardingCard'
import { useNavigate } from 'react-router'
import { RegisterModal } from 'components/modals/RegisterModal'
import { OnBoardingContainer } from 'components/ui/OnBoardingContainer'

export const RegisterPage = () => {
  const navigate = useNavigate()

  const onSuccessRegister = () => {
    navigate('/authenticated/areas')
  }

  return (
    <OnBoardingContainer>
      <OnBoardingCard>
        <RegisterModal onSuccess={onSuccessRegister} />
      </OnBoardingCard>
    </OnBoardingContainer>
  )
}
